var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/close_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/close_24px_2",
    d: "M12.6673 4.27325L11.7273 3.33325L8.00065 7.05992L4.27398 3.33325L3.33398 4.27325L7.06065 7.99992L3.33398 11.7266L4.27398 12.6666L8.00065 8.93992L11.7273 12.6666L12.6673 11.7266L8.94065 7.99992L12.6673 4.27325Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.07ab3d8b9050b055559115fce74a2697.svg";
export { ForwardRef as ReactComponent };